import {useCallback, useState} from 'react'
import type {AddProjectRequest} from '@app/api-resolver/router'
import {FormFields} from './FormFields.tsx'
import {FormValues} from './FormValues.ts'
import {useProjects} from '../../../../providers/projects/useProjects.ts'
import {EditModeButtons} from '../../../calendar/components/EditModeButtons.tsx'
import {HexColor} from '@package/shared'
import {useForm} from '@mantine/form'
import {zod4Resolver} from 'mantine-form-zod-resolver'

type Props = {
  onSuccess: () => void
  disabled: boolean
}

const defaultColor = HexColor.parse('#868e96')
export const AddForm = ({onSuccess, disabled: containerDisabled}: Props) => {
  const {addProject} = useProjects()
  const [adding, setAdding] = useState<boolean>(false)
  const form = useForm<FormValues>({
    initialValues: {
      name: '',
      color: defaultColor,
      workdays: {},
    } satisfies FormValues,
    validate: zod4Resolver(FormValues),
  })

  const handleSubmit = useCallback(
    async (formValues: FormValues) => {
      setAdding(true)
      await addProject({...formValues} satisfies AddProjectRequest).finally(() => setAdding(false))
      onSuccess()
    },
    [addProject, onSuccess],
  )

  const disabled = containerDisabled

  return (
    <form onSubmit={form.onSubmit(handleSubmit)} style={{display: 'flex', flexDirection: 'column', gap: 10}}>
      <FormFields form={form} disabled={disabled} />
      <EditModeButtons submitVariant={'add'} submitting={adding} disabled={disabled} />
    </form>
  )
}
